import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

// Services && Constants
import { STATUS_ARRIVED, STATUS_RADIOLOGY_FINISHED } from 'src/services/constants';
import { dateWithTimezone } from 'src/services/date';
import { getAdditionalObj, getEntityObj } from 'src/services/appointment';

// Styles & Images
import { hourglassImage } from 'src/views/practitioner/services/svgImages';
const DelayWrapper = styled.span`
  font-size: 14px;
  color: ${p => p.theme.color.error};
  position: relative;
  padding-left: ${p => (p.paddingRight ? '.3em' : 'inherit')};
  svg {
    width: 9px;
    height: 12px;
    position: relative;
    bottom: -1px;
  }
`;

export default function ArrivalDelay({ appointment, withBrackets }) {
  const arrivalDateTime =
    getAdditionalObj(appointment) && getAdditionalObj(appointment).arrivalDateTime;
  const appointmentStatus = getEntityObj(appointment) && getEntityObj(appointment).state;
  let delay;
  if (
    arrivalDateTime &&
    appointmentStatus &&
    (STATUS_ARRIVED === appointmentStatus || STATUS_RADIOLOGY_FINISHED === appointmentStatus)
  ) {
    const start = moment(dateWithTimezone(appointment.dateTime, 'YYYY-MM-DDTHH:mm:ss'));
    const arrive = moment(dateWithTimezone(arrivalDateTime, 'YYYY-MM-DDTHH:mm:ss'));
    if (arrive - start > 0) {
      // only if arrive > appointment time
      //   for format HH:mm
      //   const diff = moment.utc(arrive.diff(start));
      //   const hours = Number(diff.format('HH'));
      //   const minutes = Number(diff.format('mm'));
      //   if (hours) {
      //     delay = diff.format('HH:mm');
      //   } else if (!hours && minutes >= 5) {
      //     delay = `${diff.format('mm')} mins`;
      //   }
      const minutes = arrive.diff(start, 'minute');
      if (minutes >= 5) {
        delay = `${minutes} mins`;
      }
    }
  }
  return delay ? (
    <DelayWrapper className="delay-timer" paddingRight={withBrackets}>
      {withBrackets ? ' (' : null}
      {hourglassImage('#e34d57')} {delay}
      {withBrackets ? ')' : null}
    </DelayWrapper>
  ) : null;
}
